@if(loadingSpinner$ | async) {
  <loading-component class="loading" />
}

<div role="dialog" aria-labelledby="modalAddEditNotes" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="modalAddEditNotes">
          {{ 'attendance.note.editNoteTitle' | translate }}
          <br>
          <span class="text-muted fw-normal font-14">{{ 'attendance.note.editNoteSubtitle' | translate }}</span>
        </h4>
        <button type="button" class="btn-close" [mat-dialog-close]="true" aria-hidden="true"></button>
      </div>
      <div class="modal-body custom-scroll-bar">
        @if (notes$ | async; as notes) {
          @if (notes.length > 0) {
            @for (note of notes; track note; let last = $last) {
              <div 
                (click)="selectNoteForEdit(note)"
                [class.border-bottom]="!last"
                class="border-bottom border-1 border-dashed"
              >
                <div class="d-block w-100 my-3">
                  <div class="d-flex align-items-center slide-in-from-top">
                    <div class="flex-shrink-0 me-3">
                      <div class="avatar-sm">
                        <span class="avatar-title bg-warning-lighten text-warning rounded">
                          <i class="mdi mdi-file-document-edit font-24"></i>
                        </span>
                      </div>
                    </div>
                    <div class="flex-grow-1 d-flex align-items-center justify-content-between">
                      <span class="d-flex flex-column w-100">
                        @if (selectedNote && selectedNote._id === note._id) {
                          <form [formGroup]="formGroup" (ngSubmit)="save()">
                            <input 
                              class="form-control" 
                              matInput 
                              formControlName="description" 
                              [placeholder]="'attendance.note.noteDescriptionPlaceholder' | translate"
                            >
                          </form>
                        } @else {
                          <h5 class="mt-0 mb-1">{{ note.description }}</h5>
                          <p class="mb-0 font-12">
                            {{ note.updatedAt | timezoneDate: 'DD/MM/YYYY HH:mm': getTimezoneCompanyCurrentUser() }}
                          </p>
                        }
                      </span>

                      <span class="d-flex align-items-center gap-2">
                        @if (!(selectedNote && selectedNote._id === note._id)) {
                          <a href="javascript:void(0);" class="dropdown-item ms-3" (click)="selectNoteForEdit(note)">
                            <i class="ri-edit-line font-18"></i>
                          </a>
                            
                        } @else {
                          <a href="javascript:void(0);" class="dropdown-item ms-3" (click)="save()">
                            <i class="ri-check-line font-18"></i>
                          </a>
                        }

                        <a href="javascript:void(0);" class="dropdown-item" (click)="onDelete(note)">
                          <i class="ri-delete-bin-5-line text-danger font-18" ></i>
                        </a>
                      </span>
                    </div>
                    
                  </div>
                </div>
              </div>
            }
          } @else {
            <p>{{ 'attendance.note.noNotesAdded' | translate }}</p>
          }
        }


        <p class="text-muted font-14">
          {{ 'attendance.note.totalNotes' | translate }}
          <strong> {{ (notes$ | async)?.length }}</strong>
        </p>

        <form [formGroup]="formGroup" (ngSubmit)="save()" class="mt-4">
          <div class="d-flex gap-2">
            <input 
              class="form-control"
              matInput
              formControlName="description"
              [placeholder]="'attendance.note.noteDescriptionPlaceholder' | translate"
              [attr.disabled]="selectedNote ? true : null"
            >
            <button 
              class="btn btn-dark btn-sm"
              type="submit"
              [attr.disabled]="selectedNote ? true : null"
            >
              {{ 'attendance.note.save' | translate }}
            </button>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button
          class="btn btn-primary"
          [matDialogClose]="false"
        >
          {{ 'attendance.note.close' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

